<template>
  <svg width="9" height="1" viewBox="0 0 9 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 0L9 1L-4.37114e-08 1L0 -3.93402e-07L9 0Z" fill="black" />
  </svg>
</template>

<script>
export default {
  name: "MinusIcon"
}
</script>
